import { List, Create, Edit, Users } from "../Components/index.js";

export default [
    {
        path: "/admin/division/:division_id/district",
        component: List,
        name: "district-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/division/:division_id/district/:id/edit",
        component: Edit,
        name: "district-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/district/:district_id/users",
        component: Users,
        name: "district-users",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/division/:division_id/district/create",
        component: Create,
        name: "district-create",
        meta: {
            requiresAuth: true,
        },
    },
];
